import styled from 'styled-components';
import { Picture } from '../../fuse-picture/src/picture';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const StyledBrandCard = styled.a.attrs({
	className: 'fuse-brand-card',
})`
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: var(--spacing-global-space4); // 12px
	justify-content: flex-start;
	// To offset outline within carousel when keyboard focus is applied
	outline-offset: calc(-(var(--spacing-global-space1)));
	// To offset outline within carousel when keyboard focus is applied
	padding: var(--spacing-global-space1);
	text-decoration: none;

	&:focus-visible {
		outline: var(--border-width-s) solid var(--color-functional-focus);
	}

	&:focus:not(:focus-visible) {
		outline: none;
	}

	${() => {
		const textDecorationUnderline = (colour) => `
			text-decoration-line: underline;
			text-decoration-color: ${colour};
			text-decoration-style: solid;
			text-decoration-thickness: 1px;
		`;

		return `
			&:hover .fuse-brand-card__label,
			&:focus .fuse-brand-card__label {
				color: var(--color-brand-dark);
				${textDecorationUnderline(`var(--color-brand-dark)`)}
			}

			&:active .fuse-brand-card__label {
				color: var(--color-global-black);
				${textDecorationUnderline(`var(--color-global-black)`)}
			}
		`;
	}};
`;

const StyledImageWrapper = styled.div
	.withConfig({
		shouldForwardProp: (prop) => prop !== 'isLogoOnly',
	})
	.attrs({
		className: 'fuse-brand-card__image-wrapper',
		'data-testid': 'fuse-brand-card-image-wrapper-test-id',
	})`
	position: relative;
	text-align: center;
	width: 100%;

	${({ isLogoOnly }) =>
		isLogoOnly
			? `
				align-items: center;
				display: flex;
	`
			: ``}
`;

const StyledBackgroundImage = styled(Picture)
	.withConfig({
		shouldForwardProp: (prop) => prop !== 'imageSrc',
	})
	.attrs({
		className: 'fuse-brand-card__image-background',
	})`
	display: flex;
	margin: 0;

	& .fuse-picture__img {
		aspect-ratio: 3/4;
		object-fit: cover;
		width: 100%;
	}
`;

const StyledLogoImage = styled(Picture)
	.withConfig({
		shouldForwardProp: (prop) => !['imageSrc', 'isLogoOnly'].includes(prop),
	})
	.attrs({
		className: 'fuse-brand-card__image-logo',
	})`

	display: flex;
	justify-content: center;
	left: 50%;
	margin: 0;
	position: absolute;
	transform: translate(-50%, -50%);
	top: 50%;
	width: 80%;

	& .fuse-picture__img {
		aspect-ratio: 16/9;
		object-fit: scale-down;
		width: 100%;
	}
	
	${({ isLogoOnly }) =>
		isLogoOnly
			? `
				position: static;
				transform: unset;
				width: 100%;
			`
			: `
			`}
`;

const StyledLabel = styled(TypographyComponent)
	.withConfig({
		shouldForwardProp: (prop) => prop !== 'isLogoOnly',
	})
	.attrs({
		className: 'fuse-brand-card__label',
		'data-testid': 'fuse-brand-card-label-test-id',
		size: '1',
		type: 'paragraph',
	})`
	${({ isLogoOnly }) => `
		text-align: ${isLogoOnly ? 'center' : 'left'};
	`}
	color: var(--color-global-grey1000);
	overflow: hidden;
	margin-bottom: 0;
`;

export { StyledLabel, StyledBackgroundImage, StyledBrandCard, StyledImageWrapper, StyledLogoImage };
